import { vPicklist, vPipe, vTransform } from '../validation/index.ts'

const sortDirInts = [1, -1] as const
const sortDirStrings = ['1', '-1'] as const
const sortDirDescriptions = ['asc', 'desc', 'ascending', 'descending'] as const

export type SortDir = (typeof sortDirInts)[number]

export const allSortDirections = [
  ...sortDirInts,
  ...sortDirStrings,
  ...sortDirDescriptions,
] as const
type SortDirInput = (typeof allSortDirections)[number]

export const parseSortDir = (v: SortDirInput | string): SortDir | undefined => {
  switch (v) {
    case -1:
    case '-1':
    case 'desc':
    case 'descending':
      return -1
    case 1:
    case '1':
    case 'asc':
    case 'ascending':
      return 1
    default:
      return undefined
  }
}
export const sortDirSchema = vPipe(
  vPicklist(allSortDirections),
  vTransform(v => parseSortDir(v)),
)
